import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetSelectedLeadAccount = () => getDefaultState().selectedLeadAccount;

const updateSelectedLeadAccount = (state, action) => action.payload;

export default (state = getDefaultState().selectedLeadAccount, action) => {

    const actionTypes = {
        [actions.RESET_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT]: resetSelectedLeadAccount,
        [actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT]: updateSelectedLeadAccount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/selected-lead-account.js